import React, { Component } from 'react';
import SizeAndQtyFieldsArray from './SizeAndQtyFieldsArray'


export class SingleOrderFromArray extends Component {
    constructor(props) {
        super(props);
        this.state = {
            singleOrderArray: []
        }
    }

    
    componentDidMount() {
        console.log("siniya:"+this.props.siniya);
        this.initSingleOrderArray();
    }

    initSingleOrderArray = () => {

        let orderArray = [];
        


        //for TEMPLATE ADD THREE OBJECTS TO ARRAY
        if (this.props.template && this.props.templateComponents.length > 0) {
            console.log("obx8 its a template adding extra size qty feilds to array:"+this.props.templateComponents.length);
            console.log("obx812 templateComponents:"+JSON.stringify(this.props.templateComponents, null,3))

            for (let o of this.props.templateComponents) {
                console.log("obx81 inside loop:");
                orderArray.push(this.getSingleOrderObject());
                // expected output: 1
              
                //break; // closes iterator, triggers return
              }

            console.log("obx82 lenght after:"+orderArray.length);
            console.log("obx82 single order array:"+JSON.stringify(orderArray, null,3))
        } else {
            console.log("obx84 not a template - this.props.template IS false");
            orderArray.push(this.getSingleOrderObject());
        }


        this.setState({
            singleOrderArray: orderArray,
            arrayLoadingComplete:true
        })

        return orderArray;
    }

    getSingleOrderObject = () => {
        console.log("obx86 ++++++ getSingleOrderObject");
        let IndyOrder = {

            //fa handleOrderDetailsDropDownChanges={ props.handleOrderDetailsDropDownChangesOrderTwo }
            //   handleTextInputChange={ props.handleTextInputChange }
            // shirtColor: '',
            // shirtSize: '',
            // shirtType: '',
            // qty: '',
            // qtyTextFeildName: '',
            // topDividerText: '',
            // visible: '',
            // // handleAddMoreClick: '', 
            // formErrorFieldArray: '',
            // order2Visible: '',
            // order3Visible: '',
            // itemSelected: '',
            // jerseyNumberFieldName: '',
            // jerseyNameFieldName: '',
            // jerseyNumber: '',
            // jerseyName: '',
            // //FOOTBACLL
            // teamSelection: '',
            // selectedTeamColors: '',
            // shirtColors: '',
            // typedInTeamNameFieldName: '',
            // typedInTeamName: '',
            // shirtSizes: '',
            // childsAgeTextFeildName: ''
        }

        return IndyOrder;
    }

    handleAddMoreClick = (itemType,topDividerText) => {
        console.log("hax1 +++++++: handle add more");
        console.log("hax01 itemType:"+itemType);
        console.log("hax02 topDividerText:"+topDividerText);

        console.log("hax12 current size:" + this.state.singleOrderArray.length);
        let orderArray = this.state.singleOrderArray;
        orderArray.push(this.getSingleOrderObject())


        this.setState({
            singleOrderArray: orderArray
        })
    }


    updateOrderArray = (index, item, value) => {
        console.log("+++++++: updateOrderArray");
        console.log("idx1 cxx5 obx101 : index:" + index);
        console.log("idx2: cxx51 obx102 item:" + item);
        console.log("idx3: cxx52 obx103 value:" + value);

        let orderArray = this.state.singleOrderArray;

        orderArray[index][item] = value;
        console.log("idx4 cxx53 obx10: value set:" + orderArray[index][item]);

        this.setState({
            singleOrderArray: orderArray
        })

        //SEND ORDER ARRAY TO MAIN ORDER FORM
        //UPDATE ORDER ARRAY

        this.props.updateSingleOrderArray(orderArray);

    }

      //GET CARD OBJET TO SEND TO SINGL ORDER QTY ARRAY..
      getCardObjectFromTemplateComponent = (templateComponent, templateComponentComposite) =>{
        console.log("obx85 ++++++++++:getCardObjectFromTemplateComponent");

        let tempCardObject = {};

        tempCardObject.key = templateComponentComposite.templateComponent.itemType;
        tempCardObject.itemTypeDescription = templateComponentComposite.templateComponent.itemDescription;
        tempCardObject.itemType = templateComponentComposite.templateComponent.itemType;
        tempCardObject.fullDescription = templateComponentComposite.templateComponent.fullTotalDescription;
        tempCardObject.template = true;
        tempCardObject.objectKey = templateComponentComposite.templateComponent.itemType;
        tempCardObject.shortDescriptions = templateComponentComposite.templateComponent.itemDescription;
        tempCardObject.valid = true;
        tempCardObject.wordsOnFront = templateComponentComposite.templateComponent.wordsOnFront === 1 ? true : false;
        tempCardObject.wordsOnItemLabel = templateComponentComposite.templateComponent.wordsOnItemLabel;

        tempCardObject.wordsOnBack = templateComponentComposite.templateComponent.wordsOnBack === 1 ? true : false;
        tempCardObject.wordsOnBackItemLabel = templateComponentComposite.templateComponent.wordsOnBackItemLabel;

        tempCardObject.imageUploadButtonLabel = "Pls upload image";
        tempCardObject.imageUpload = templateComponentComposite.templateComponent.imageUpload === 1 ? true : false;

        //TEMPLATE TYPE
        tempCardObject.templatetype  = templateComponentComposite.templateComponent.template.templateType.templateType;
        console.log("obx8501 templateType:"+tempCardObject.templatetype);

        //SHIRT SIZES
        tempCardObject.showShirtSizes = templateComponentComposite.templateComponent.showShirtSizes === 1 ? true : false;

        if(tempCardObject.showShirtSizes){
            console.log("obx851 shirts sizes is true");
            tempCardObject.shirtSizes = templateComponentComposite.shirtSizes;
        }

        tempCardObject.showSizePrices = templateComponentComposite.templateComponent.showSizePrices === 1 ? true : false;
        if(tempCardObject.showSizePrices){
            console.log("obx8512 showSizePrices is true");
            tempCardObject.showSizePrices = templateComponentComposite.showSizePrices;
        }

        //SHIRT TYPES
        tempCardObject.showShirtCollars = templateComponentComposite.templateComponent.showShirtCollars === 1 ? true : false;
        if(tempCardObject.showShirtCollars){
            console.log("obx852 showShirtTypes sizes is true");
            tempCardObject.shirtCollars = templateComponentComposite.shirtCollars;
        }

 
        //SHIRT COLORS
        tempCardObject.showShirtColors = templateComponentComposite.templateComponent.showShirtColors === 1 ? true : false;
        if(tempCardObject.showShirtColors){
            console.log("obx853 showShirtColors sizes is true");
            tempCardObject.shirtColors = templateComponentComposite.shirtColors;
        }
        
        //DEFAULT SHIRT TYPE
        tempCardObject.defaultShirtType = templateComponentComposite.templateComponent.defaultShirtType 
        ? templateComponentComposite.templateComponent.defaultShirtType.shirtType
        : false;
        console.log("obx856 tempCardObject.defaultShirtType:"+tempCardObject.defaultShirtType);

        //console.log("obx86 tempCardObject:"+JSON.stringify(tempCardObject, null, 3));

        return tempCardObject;
        // {
        //     "grouping": "mainCardObjects",
        //     "key": "wristband",
        //     "image": "https://firebasestorage.googleapis.com/v0/b/printb-3daaa.appspot.com/o/siteImages%2Fbracelet%2Fbangles_6001-min.jpg?alt=media&token=5cd697da-6ce9-4aa0-88e6-26f89da0a14c",
        //     "imageSize": "massive",
        //     "itemTypeDescription": "Custom Wristbands",
        //     "itemType": "wristband",
        //     "fullDescription": "Create Custom WristBands",
        //     "template": false,
        //     "objectKey": "wristband",
        //     "shortDescriptions": "5,000 UGX EA",
        //     "itemPrice": "5,000",
        //     "valid": true,
        //     "wordsOnFront": false,
        //     "wordsOnBack": false,
        //     "objectID": "45923422"
        //   }

    }

    render() {

        const singleOrderArray = this.state.arrayLoadingComplete 
                                    && this.state.singleOrderArray.length > 0
                                    && !this.props.templateComponents
            ? this.state.singleOrderArray.map((singelOrder, index) =>


            <SizeAndQtyFieldsArray
                key={index}
                arrayIndex={index}
                handleOrderDetailsDropDownChanges={this.props.handleOrderDetailsDropDownChanges}
                handleTextInputChange={this.props.handleTextInputChange}
                shirtColor={this.props.shirtColor1}
                shirtSize={this.props.shirtSize1}
                shirtType={this.props.shirtType1}
                qty={this.props.qty1}
                qtyTextFeildName={'qty1'}
                topDividerText={'Order ' + (index + 1)}
                visible={true}
                handleAddMoreClick={this.handleAddMoreClick}
                formErrorFieldArray={this.props.formErrorFieldArray}
                order2Visible={this.props.order2Visible}
                order3Visible={this.props.order3Visible}
                itemSelected={this.props.itemSelected}
                jerseyNumberFieldName={'jerseyNumber1'}
                jerseyNameFieldName={'jerseyName1'}
                jerseyNumber={this.props.jerseyNumber1}
                jerseyName={this.props.jerseyName1}
                //FOOTBACLL
                teamSelection={this.props.teamSelection1}
                selectedTeamColors={this.props.selectedTeamColors1}
                shirtColors={this.props.shirtColors1}
                typedInTeamNameFieldName={'typedInTeamName1'}
                typedInTeamName={this.props.typedInTeamName1}
                //CHILD

                childsAgeTextFeildName={'childsAge1'}
                updateOrderArray={this.updateOrderArray}
                //TEMPLATE
                selectDateTemplate={this.props.selectDateTemplate}
                monthTemplate={this.state.monthTemplate}
                templateGenericFieldName={'templateGenericField'}
                templateGenericField={this.props.templateGenericField}
                templateSpecialFieldLabel={this.props.templateSpecialFieldLabel}

                wordsOnItemLabel={this.props.wordsOnItemLabel}
                faceShirt={this.props.faceShirt}
                admin={this.props.admin}
                //SINIYA
                siniya={this.props.siniya}
                cardObject = {this.props.cardObject}
            />

        )
        :''

      
        
        const templateComponentsUI = this.state.arrayLoadingComplete 
                                    && this.props.templateComponents
                                    && this.props.templateComponents.length > 0
        ? this.state.singleOrderArray.map((singelOrder, index) =>

            <SizeAndQtyFieldsArray
                key={index}
                arrayIndex={index}
                handleOrderDetailsDropDownChanges={this.props.handleOrderDetailsDropDownChanges}
                handleTextInputChange={this.props.handleTextInputChange}
                shirtColor={this.props.shirtColor1}
                shirtSize={this.props.shirtSize1}
                shirtType={this.props.shirtType1}
                qty={this.props.qty1}
                qtyTextFeildName={'qty1'}
               // topDividerText={this.props.templateComponents[index].itemTypeRel.itemType}

                // FOR REGULAR ORDERS, ADD MORE WILL ADD WITH NORMAL indyOrderHeader BUT WITH WORLD CUP
                // WE HAVE TO MASK THE indyOrderHeader TO NOT THROW AN ERROR
                topDividerText={this.props.templateComponents[index] ? this.props.templateComponents[index].indyOrderHeader : 'Order'}
               // topDividerText={'testing'}

                visible={true}
                handleAddMoreClick={this.handleAddMoreClick}
                formErrorFieldArray={this.props.formErrorFieldArray}
                order2Visible={this.props.order2Visible}
                order3Visible={this.props.order3Visible}

               // itemSelected={this.props.templateComponents[index] ? this.props.templateComponents[index].itemTypeRel.itemType : 'football'}

                itemSelected={this.props.templateComponents[index] ? this.props.templateComponents[index].itemTypeRel.itemType : this.props.itemSelected}

                //CREATE THE CARD OBJECT TO SEND TO SINGLE QTY ARRAY..
                cardObject = {this.getCardObjectFromTemplateComponent(this.props.templateComponents[index], this.props.templateComponentComposite[index])}
                
                //itemSelected={'football'}
                
                jerseyNumberFieldName={'jerseyNumber1'}
                jerseyNameFieldName={'jerseyName1'}
                jerseyNumber={this.props.jerseyNumber1}
                jerseyName={this.props.jerseyName1}
                //FOOTBACLL
                teamSelection={this.props.teamSelection1}
                selectedTeamColors={this.props.selectedTeamColors1}
                shirtColors={this.props.shirtColors1}
                typedInTeamNameFieldName={'typedInTeamName1'}
                typedInTeamName={this.props.typedInTeamName1}
                //CHILD
                childsAgeTextFeildName={'childsAge1'}
                updateOrderArray={this.updateOrderArray}
                //TEMPLATE
                selectDateTemplate={this.props.selectDateTemplate}
                monthTemplate={this.state.monthTemplate}
                templateGenericFieldName={'templateGenericField'}
                templateGenericField={this.props.templateGenericField}
                templateSpecialFieldLabel={this.props.templateSpecialFieldLabel}
                wordsOnItemLabel={this.props.wordsOnItemLabel}

                ivanDescription = {this.props.ivanDescription}

                faceShirt={this.props.faceShirt}
                admin={this.props.admin}
                template={true}
                //SINISYA
                siniya={this.props.siniya}
                //tempate
                sentTemplate={this.props.sentTemplate}
            />
            
        )
        :''

        return (
            <div>
                {singleOrderArray}
                {templateComponentsUI}
            </div>
        )
    }
}

export default SingleOrderFromArray;


// WEBPACK FOOTER //
// ./src/components/newSite/SingleOrderFromArray/SingleOrderFromArray.js